import styled from 'styled-components';
import { Divider } from 'antd';

const JDivider = styled(Divider)`
  background: #d4d4d4;
  margin: 20px 5px;
`;

export default JDivider;
